var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"grey--text text--darken-1"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('vue-editor',{attrs:{"editor-toolbar":_vm.customToolbar},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }